export default __webpack_public_path__ + "static/7-alternative-japanese-destinations-japan-74fc33621924e673b16966d96cb05500.jpg";